import * as React from 'react'
import { createContext, MaybeRenderProp } from '@clara/react-utils'
import { runIfFn, __DEV__ } from '@clara/utils'
import { useDetail, useDetailProps, useDetailReturn } from './use-detail'

export interface DetailContext extends useDetailReturn {}

export const [DetailContextProvider, useDetailContext] =
  createContext<DetailContext>({
    strict: true,
    name: 'useDetailContext',
    errorMessage:
      'useDetailContext: `context` is undefined. Seems you forgot to wrap company components in `<ReimbursementDetailProvider />`',
  })

export interface ActivityProps extends useDetailProps {
  children?: MaybeRenderProp<DetailContext>
}

export const ReimbursementDetailProvider: React.FC<ActivityProps> = (props) => {
  const ctx = useDetail()
  const context = React.useMemo(() => ctx, [ctx])
  const children = runIfFn(props.children, context)

  return (
    <DetailContextProvider value={context}>{children}</DetailContextProvider>
  )
}

if (__DEV__) {
  ReimbursementDetailProvider.displayName = 'ReimbursementDetailProvider'
}
